import React from 'react';
import { UploadDocumentController } from '../order/documentsPortal/standardDocuments/UploadDocumentController';
import { IUploadDocument } from '../../types/order/documents/upload/interfaces';
import { resetUploadDocumentStatus, uploadVendorDocuments } from '../../store/vendorStore/vendorDocuments/dispatch';
import { UUID } from '../../types/shared/UUID';
import { useSelector } from 'react-redux';
import { VendorSelectors } from '../../selectors/vendorPortal/VendorSelectors';
import { DocumentCategoriesByName, IDocumentCategory } from '../../types/order/documents/IDocumentCategoryType';
import { useAppDispatch } from '../../store/store';

export const UploadContainer: React.FC<{
  orderId: UUID;
  documentCategoriesByName: DocumentCategoriesByName;
  documentCategoryFilter?: (category: IDocumentCategory) => boolean;
}> = ({ orderId, documentCategoriesByName, documentCategoryFilter }) => {
  const dispatch = useAppDispatch();
  const onUploadDocuments = async (documents: IUploadDocument[]) => {
    dispatch(uploadVendorDocuments(orderId, documents));
  };
  const onUploadDocumentReset = () => {
    dispatch(resetUploadDocumentStatus(orderId));
  };

  const { uploadDocumentsFetchStatus } = useSelector(VendorSelectors.selectDocuments);

  return (
    <UploadDocumentController
      documentCategoriesByName={documentCategoriesByName}
      documentCategoryFilter={documentCategoryFilter}
      onSubmit={onUploadDocuments}
      onReset={onUploadDocumentReset}
      uploadFetch={uploadDocumentsFetchStatus}
    />
  );
};
